import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const BASE_URL   = "https://senutour.com/api";
const CLOUD_NAME = "dhs2cu6vv"; // ton cloudinary
const UPLOAD_PRESET = "senutour_unsigned"; // à créer dans Cloudinary (unsigned preset)

const getToken = () => localStorage.getItem("token");
const getUser  = () => JSON.parse(localStorage.getItem("user") || "{}");

// ── Icônes SVG ──────────────────────────────────────────────────
const IcHome    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcCalendar= () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcHistory = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcGrid    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcUpload  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IcTrash   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>;
const IcEdit    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IcCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcX       = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcPhone   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.82 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcMail    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;

const TYPE_LABELS = {
  appartement:        "Appartement",
  appartement_meuble: "Appartement meublé",
  villa:              "Villa",
  hotel:              "Hôtel",
  studio:             "Studio",
  auberge:            "Auberge",
};

const EQUIPEMENTS_LISTE = [
  "WiFi", "Climatisation", "Parking", "Piscine", "Cuisine équipée",
  "Télévision", "Machine à laver", "Sécurité 24h", "Générateur",
  "Eau chaude", "Terrasse", "Jardin",
];

const STATUT_RESA = {
  confirmee:  { label: "Confirmée",  color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  en_attente: { label: "En attente", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  annulee:    { label: "Annulée",    color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
};

const ONGLETS = [
  { id: "dashboard",    label: "Vue générale",  Icon: IcGrid },
  { id: "logements",    label: "Mes logements", Icon: IcHome },
  { id: "reservations", label: "Réservations",  Icon: IcCalendar },
  { id: "historique",   label: "Historique",    Icon: IcHistory },
];

const FORM_VIDE = {
  nom: "", adresse: "", quartier: "", type: "appartement", ville: "Dakar",
  prix: "", capacite: "", etoiles: "3", heureDepart: "11:00",
  description: "", numeroProprietaire: "", equipements: [],
};

const formatDate = (d) => d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "";
const formatPrix = (p) => p ? Number(p).toLocaleString("fr-FR") + " F" : "—";

export default function BailleurDashboard() {
  const navigate = useNavigate();
  const user = getUser();
  const fileInputRef = useRef();

  const [onglet, setOnglet]           = useState("dashboard");
  const [showForm, setShowForm]       = useState(false);
  const [editingId, setEditingId]     = useState(null); // id du logement en cours de modification, null = création
  const [logements, setLogements]     = useState([]);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading]         = useState(true);
  const [uploading, setUploading]     = useState(false);
  const [saving, setSaving]           = useState(false);
  const [photos, setPhotos]           = useState([]); // URLs Cloudinary
  const [form, setForm]               = useState(FORM_VIDE);
  const [filtreStatut, setFiltreStatut] = useState("tous");

  // ── Chargement ──────────────────────────────────────────────
  useEffect(() => {
    const charger = async () => {
      try {
        const [resH, resR] = await Promise.all([
          fetch(`${BASE_URL}/hotels/mes-logements`, {
            headers: { Authorization: `Bearer ${getToken()}` },
          }),
          fetch(`${BASE_URL}/reservations/bailleur`, {
            headers: { Authorization: `Bearer ${getToken()}` },
          }),
        ]);
        const hotels = await resH.json();
        const resas  = await resR.json();
        setLogements(Array.isArray(hotels) ? hotels : []);
        setReservations(Array.isArray(resas) ? resas : []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    charger();
  }, []);

  // ── Upload photos Cloudinary ─────────────────────────────────
  const handlePhotos = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      const urls = await Promise.all(files.map(async (file) => {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("upload_preset", UPLOAD_PRESET);
        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
          method: "POST",
          body: fd,
        });
        const data = await res.json();
        return data.secure_url;
      }));
      setPhotos(prev => [...prev, ...urls]);
    } catch (e) {
      alert("Erreur upload photo. Vérifiez votre preset Cloudinary.");
    } finally {
      setUploading(false);
    }
  };

  const supprimerPhoto = (url) => setPhotos(prev => prev.filter(p => p !== url));

  // ── Toggle équipement ────────────────────────────────────────
  const toggleEquipement = (eq) => {
    setForm(prev => ({
      ...prev,
      equipements: prev.equipements.includes(eq)
        ? prev.equipements.filter(e => e !== eq)
        : [...prev.equipements, eq],
    }));
  };

  // ── Ouvrir le formulaire vide (nouveau logement) ──────────────
  const ouvrirNouveauLogement = () => {
    setEditingId(null);
    setForm(FORM_VIDE);
    setPhotos([]);
    setShowForm(true);
  };

  // ── Ouvrir le formulaire pré-rempli (modification) ────────────
  const modifierLogement = (logement) => {
    setEditingId(logement.id);
    setForm({
      nom: logement.nom || "",
      adresse: logement.adresse || "",
      quartier: logement.quartier || "",
      type: logement.type || "appartement",
      ville: logement.ville || "Dakar",
      prix: logement.prix != null ? String(logement.prix) : "",
      capacite: logement.capacite != null ? String(logement.capacite) : "",
      etoiles: logement.etoiles != null ? String(logement.etoiles) : "3",
      heureDepart: logement.heureDepart || "11:00",
      description: logement.description || "",
      numeroProprietaire: logement.numeroProprietaire || "",
      equipements: logement.equipements || [],
    });
    setPhotos(logement.images || []);
    setShowForm(true);
  };

  const annulerFormulaire = () => {
    setShowForm(false);
    setForm(FORM_VIDE);
    setPhotos([]);
    setEditingId(null);
  };

  // ── Créer ou mettre à jour un logement ────────────────────────
  const enregistrerLogement = async () => {
    if (!form.nom || !form.adresse || !form.prix) {
      alert("Nom, adresse et prix sont obligatoires.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        prix:     parseInt(form.prix),
        capacite: parseInt(form.capacite) || 4,
        etoiles:  parseInt(form.etoiles) || 3,
        images:   photos,
        disponible: true,
      };

      const url    = editingId ? `${BASE_URL}/hotels/${editingId}` : `${BASE_URL}/hotels`;
      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok) {
        if (editingId) {
          // on fusionne la réponse serveur si elle renvoie l'objet mis à jour,
          // sinon on retombe sur le payload local
          setLogements(prev => prev.map(l =>
            l.id === editingId ? { ...l, ...(data.hotel || payload), id: editingId } : l
          ));
        } else {
          setLogements(prev => [...prev, data.hotel]);
        }
        annulerFormulaire();
      } else {
        alert(data.message || "Erreur lors de l'enregistrement.");
      }
    } catch (e) {
      alert("Erreur serveur.");
    } finally {
      setSaving(false);
    }
  };

  // ── Supprimer logement ───────────────────────────────────────
  const supprimerLogement = async (id) => {
    if (!window.confirm("Supprimer ce logement ?")) return;
    await fetch(`${BASE_URL}/hotels/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    setLogements(prev => prev.filter(l => l.id !== id));
  };

  // ── Confirmer / Annuler réservation ──────────────────────────
  const confirmerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations/${id}/confirmer`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "confirmee" } : r));
  };

  const annulerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations/${id}/annuler`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "annulee" } : r));
  };

  // ── Stats ────────────────────────────────────────────────────
  const resasAttente   = reservations.filter(r => r.statut === "en_attente");
  const resasConfirmees = reservations.filter(r => r.statut === "confirmee");
  const resasFiltrees  = filtreStatut === "tous" ? reservations : reservations.filter(r => r.statut === filtreStatut);

  const labelStyle = {
    display: "block", fontSize: 11, fontWeight: 700, color: "#7A5A3A",
    textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6,
  };
  const inputStyle = {
    width: "100%", boxSizing: "border-box", padding: "11px 14px",
    border: "1.5px solid #E8DCC8", borderRadius: 10,
    fontFamily: "'Space Grotesk',sans-serif", fontSize: 14,
    outline: "none", color: "#1C1008", background: "white",
  };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF5EC", fontFamily: "'Space Grotesk',sans-serif", color: "#7A5A3A" }}>
      Chargement…
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{ fontFamily: "'Space Grotesk',sans-serif", background: "#FAF5EC", minHeight: "100vh", color: "#1C1008" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .onglet-btn { transition: all .2s; cursor: pointer; border: none; background: none; }
          .onglet-btn:hover { color: #C4441A !important; }
          .btn-primary { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
          .btn-primary:hover { background: #A03614; }
          .btn-success { background: #3D6B2E; transition: background .2s; border: none; cursor: pointer; }
          .btn-success:hover { background: #2D5220; }
          .card-hover { transition: all .2s; }
          .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          .eq-pill { cursor: pointer; transition: all .15s; user-select: none; }
          .eq-pill:hover { border-color: #C4441A !important; }
          .photo-zone { border: 2px dashed #E8DCC8; border-radius: 12px; padding: 32px; text-align: center; cursor: pointer; transition: border-color .2s; }
          .photo-zone:hover { border-color: #C4441A; }
          @media (max-width: 767px) {
            .stats-grid { grid-template-columns: 1fr 1fr !important; }
            .form-grid-2 { grid-template-columns: 1fr !important; }
            .form-grid-3 { grid-template-columns: 1fr !important; }
            .logements-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>

        {/* ── HEADER ── */}
        <div style={{ background: "linear-gradient(135deg,#1C1008 0%,#2D1A08 100%)", padding: "36px 5%", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle,rgba(196,68,26,.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />
          <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 800, color: "white", border: "3px solid rgba(255,255,255,0.2)", flexShrink: 0 }}>
                  {(user.prenom?.[0] || "")}{(user.nom?.[0] || "")}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>Dashboard Bailleur</div>
                  <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", margin: 0 }}>{user.prenom} {user.nom}</h1>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>
                    {logements.length} logement{logements.length !== 1 ? "s" : ""} · {resasAttente.length} en attente
                  </div>
                </div>
              </div>
              <button className="btn-primary" onClick={() => { setOnglet("logements"); ouvrirNouveauLogement(); }}
                style={{ color: "white", borderRadius: 10, padding: "12px 22px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}>
                + Ajouter un logement
              </button>
            </div>
          </div>
        </div>

        {/* ── ONGLETS ── */}
        <div style={{ background: "white", borderBottom: "1.5px solid #E8DCC8", padding: "0 5%", overflowX: "auto" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 4, minWidth: "max-content" }}>
            {ONGLETS.map(o => (
              <button key={o.id} className="onglet-btn" onClick={() => setOnglet(o.id)}
                style={{ padding: "16px 18px", fontSize: 13, fontWeight: 600, color: onglet === o.id ? "#C4441A" : "#7A5A3A", borderBottom: onglet === o.id ? "2px solid #C4441A" : "2px solid transparent", marginBottom: -1, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                <o.Icon /> {o.label}
                {o.id === "reservations" && resasAttente.length > 0 && (
                  <span style={{ background: "#C4441A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{resasAttente.length}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "36px 5% 60px" }}>

          {/* ══ VUE GÉNÉRALE ══ */}
          {onglet === "dashboard" && (
            <>
              <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 32 }}>
                {[
                  { label: "Logements",     value: logements.length,       color: "#C4441A" },
                  { label: "En attente",    value: resasAttente.length,    color: "#C4841A" },
                  { label: "Confirmées",    value: resasConfirmees.length, color: "#3D6B2E" },
                  { label: "Total réservations", value: reservations.length, color: "#1C1008" },
                ].map((s, i) => (
                  <div key={i} className="card-hover" style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 32, fontWeight: 800, color: s.color }}>{s.value}</div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 6, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {/* Logements récents */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes logements</h3>
                    <button onClick={() => setOnglet("logements")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {logements.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucun logement — ajoutez le vôtre !</div>
                    : logements.slice(0, 4).map((l, i, arr) => (
                      <div key={l.id} style={{ padding: "14px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none", display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 40, height: 40, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#F2E4C8" }}>
                          {l.images?.[0]
                            ? <img src={l.images[0]} alt={l.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>🏠</div>
                          }
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{l.nom}</div>
                          <div style={{ fontSize: 11, color: "#7A5A3A" }}>{TYPE_LABELS[l.type] || l.type} · {l.ville}</div>
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#C4441A" }}>{l.prix?.toLocaleString()} F</div>
                      </div>
                    ))
                  }
                </div>

                {/* Réservations en attente */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>En attente de confirmation</h3>
                    <button onClick={() => setOnglet("reservations")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {resasAttente.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucune réservation en attente</div>
                    : resasAttente.slice(0, 3).map((r, i, arr) => (
                      <div key={r.id} style={{ padding: "14px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#C4441A" }}>{formatPrix(r.total)}</div>
                        </div>
                        <div style={{ fontSize: 11, color: "#7A5A3A", marginBottom: 8 }}>{formatDate(r.dateArrivee)} → {formatDate(r.dateDepart)}</div>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button className="btn-success" onClick={() => confirmerResa(r.id)}
                            style={{ color: "white", borderRadius: 6, padding: "5px 10px", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", gap: 4 }}>
                            <IcCheck /> Confirmer
                          </button>
                          <button className="btn-primary" onClick={() => annulerResa(r.id)}
                            style={{ color: "white", borderRadius: 6, padding: "5px 10px", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", gap: 4 }}>
                            <IcX /> Refuser
                          </button>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </>
          )}

          {/* ══ MES LOGEMENTS ══ */}
          {onglet === "logements" && (
            <>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
                <div>
                  <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes logements</h2>
                  <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{logements.length} logement{logements.length !== 1 ? "s" : ""}</p>
                </div>
                <button className="btn-primary" onClick={() => (showForm ? annulerFormulaire() : ouvrirNouveauLogement())}
                  style={{ color: "white", borderRadius: 10, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                  {showForm ? "Annuler" : "+ Ajouter un logement"}
                </button>
              </div>

              {/* ── FORMULAIRE ── */}
              {showForm && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", padding: "32px", marginBottom: 28, boxShadow: "0 4px 20px rgba(28,16,8,0.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#1C1008", marginBottom: 24 }}>
                    {editingId ? "Modifier le logement" : "Nouveau logement"}
                  </h3>

                  {/* Nom + Adresse */}
                  <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 20px" }}>
                    {[
                      { label: "Nom du logement *", key: "nom",     placeholder: "Ex: Studio Plateau" },
                      { label: "Adresse *",         key: "adresse", placeholder: "Ex: Rue 10, Almadies" },
                    ].map(f => (
                      <div key={f.key} style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>{f.label}</label>
                        <input value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                          placeholder={f.placeholder} style={inputStyle} />
                      </div>
                    ))}
                  </div>

                  {/* Type + Ville + Quartier */}
                  <div className="form-grid-3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Type de logement</label>
                      <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} style={inputStyle}>
                        <option value="appartement">Appartement</option>
                        <option value="appartement_meuble">Appartement meublé</option>
                        <option value="studio">Studio</option>
                        <option value="villa">Villa</option>
                        <option value="auberge">Auberge</option>
                        <option value="hotel">Hôtel</option>
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Ville</label>
                      <select value={form.ville} onChange={e => setForm({ ...form, ville: e.target.value })} style={inputStyle}>
                        <option>Dakar</option>
                        <option>Diamniadio</option>
                        <option>Saly</option>
                        <option>Saint-Louis</option>
                        <option>Ziguinchor</option>
                        <option>Thiès</option>
                        <option>Mbour</option>
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Quartier</label>
                      <input value={form.quartier} onChange={e => setForm({ ...form, quartier: e.target.value })}
                        placeholder="Ex: Plateau, Almadies…" style={inputStyle} />
                    </div>
                  </div>

                  {/* Prix + Capacité + Étoiles + Heure départ */}
                  <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "0 16px" }}>
                    {[
                      { label: "Prix / nuit (F CFA) *", key: "prix",      placeholder: "Ex: 25000", type: "number" },
                      { label: "Capacité (personnes)",  key: "capacite",  placeholder: "Ex: 4",     type: "number" },
                      { label: "Heure de départ",       key: "heureDepart", placeholder: "11:00",   type: "time"   },
                      { label: "Numéro Wave / Orange",  key: "numeroProprietaire", placeholder: "77 000 00 00", type: "tel" },
                    ].map(f => (
                      <div key={f.key} style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>{f.label}</label>
                        <input type={f.type} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                          placeholder={f.placeholder} style={inputStyle} />
                      </div>
                    ))}
                  </div>

                  {/* Étoiles */}
                  <div style={{ marginBottom: 16 }}>
                    <label style={labelStyle}>Classement étoiles</label>
                    <div style={{ display: "flex", gap: 8 }}>
                      {[1,2,3,4,5].map(n => (
                        <button key={n} type="button" onClick={() => setForm({ ...form, etoiles: String(n) })}
                          style={{ width: 36, height: 36, borderRadius: 8, border: `1.5px solid ${form.etoiles === String(n) ? "#C4441A" : "#E8DCC8"}`, background: form.etoiles === String(n) ? "#C4441A" : "white", color: form.etoiles === String(n) ? "white" : "#7A5A3A", fontSize: 14, cursor: "pointer", fontWeight: 700 }}>
                          {n}★
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Description */}
                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Description</label>
                    <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                      placeholder="Décrivez votre logement : ambiance, points forts, accès…"
                      rows={4} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} />
                  </div>

                  {/* Équipements */}
                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Équipements disponibles</label>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {EQUIPEMENTS_LISTE.map(eq => (
                        <span key={eq} className="eq-pill" onClick={() => toggleEquipement(eq)}
                          style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: 500, cursor: "pointer", border: `1.5px solid ${form.equipements.includes(eq) ? "#C4441A" : "#E8DCC8"}`, background: form.equipements.includes(eq) ? "rgba(196,68,26,0.08)" : "white", color: form.equipements.includes(eq) ? "#C4441A" : "#7A5A3A" }}>
                          {form.equipements.includes(eq) ? "✓ " : ""}{eq}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Upload photos */}
                  <div style={{ marginBottom: 24 }}>
                    <label style={labelStyle}>Photos du logement</label>
                    <div className="photo-zone" onClick={() => fileInputRef.current?.click()}>
                      <input ref={fileInputRef} type="file" multiple accept="image/*" onChange={handlePhotos} style={{ display: "none" }} />
                      {uploading
                        ? <p style={{ color: "#7A5A3A", margin: 0, fontSize: 14 }}>Chargement des photos…</p>
                        : (
                          <>
                            <IcUpload />
                            <p style={{ color: "#7A5A3A", margin: "8px 0 4px", fontSize: 14, fontWeight: 600 }}>Cliquez pour ajouter des photos</p>
                            <p style={{ color: "#B8A898", margin: 0, fontSize: 12 }}>JPG, PNG — plusieurs fichiers acceptés</p>
                          </>
                        )
                      }
                    </div>
                    {photos.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12 }}>
                        {photos.map((url, i) => (
                          <div key={i} style={{ position: "relative", width: 80, height: 80, borderRadius: 8, overflow: "hidden" }}>
                            <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            <button onClick={() => supprimerPhoto(url)}
                              style={{ position: "absolute", top: 4, right: 4, background: "rgba(196,68,26,0.85)", border: "none", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "white" }}>
                              <IcTrash />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button onClick={annulerFormulaire}
                      style={{ background: "white", border: "1.5px solid #E8DCC8", borderRadius: 10, padding: "11px 20px", fontSize: 14, fontWeight: 600, color: "#7A5A3A", cursor: "pointer" }}>
                      Annuler
                    </button>
                    <button className="btn-primary" onClick={enregistrerLogement} disabled={saving}
                      style={{ color: "white", borderRadius: 10, padding: "11px 28px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, opacity: saving ? 0.7 : 1 }}>
                      {saving ? "Enregistrement…" : editingId ? "Mettre à jour" : "Enregistrer le logement"}
                    </button>
                  </div>
                </div>
              )}

              {/* Grille logements */}
              {logements.length === 0 && !showForm ? (
                <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A" }}>
                  <p style={{ fontSize: 15, marginBottom: 16 }}>Vous n'avez pas encore de logement enregistré.</p>
                  <button className="btn-primary" onClick={ouvrirNouveauLogement}
                    style={{ color: "white", borderRadius: 10, padding: "12px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                    + Ajouter mon premier logement
                  </button>
                </div>
              ) : (
                <div className="logements-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
                  {logements.map(l => (
                    <div key={l.id} style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                      <div style={{ height: 140, background: "linear-gradient(135deg,#1C1008,#2D1A08)", overflow: "hidden", position: "relative" }}>
                        {l.images?.[0]
                          ? <img src={l.images[0]} alt={l.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48, opacity: 0.5 }}>🏠</div>
                        }
                        <span style={{ position: "absolute", top: 10, right: 10, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: l.disponible ? "rgba(61,107,46,0.85)" : "rgba(196,68,26,0.85)", color: "white" }}>
                          {l.disponible ? "Disponible" : "Occupé"}
                        </span>
                        {l.images?.length > 1 && (
                          <span style={{ position: "absolute", bottom: 8, left: 10, fontSize: 11, color: "white", background: "rgba(0,0,0,0.5)", borderRadius: 10, padding: "2px 8px" }}>
                            {l.images.length} photos
                          </span>
                        )}
                      </div>
                      <div style={{ padding: 16 }}>
                        <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 800, color: "#1C1008", margin: "0 0 4px" }}>{l.nom}</h3>
                        <div style={{ fontSize: 12, color: "#7A5A3A", marginBottom: 6 }}>{TYPE_LABELS[l.type] || l.type} · {l.quartier ? `${l.quartier}, ` : ""}{l.ville}</div>
                        {l.equipements?.length > 0 && (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
                            {l.equipements.slice(0, 3).map(eq => (
                              <span key={eq} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 10, background: "rgba(196,68,26,0.07)", color: "#C4441A", fontWeight: 600 }}>{eq}</span>
                            ))}
                            {l.equipements.length > 3 && <span style={{ fontSize: 10, color: "#B8A898" }}>+{l.equipements.length - 3}</span>}
                          </div>
                        )}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12, borderTop: "1px solid #F2E4C8" }}>
                          <div>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 800, color: "#C4441A" }}>{l.prix?.toLocaleString()} F</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A" }}>/ nuit · {l.capacite} pers.</div>
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button onClick={() => modifierLogement(l)}
                              style={{ background: "rgba(28,16,8,0.05)", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12, fontWeight: 600, color: "#7A5A3A", cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}>
                              <IcEdit /> Modifier
                            </button>
                            <button onClick={() => supprimerLogement(l.id)}
                              style={{ background: "rgba(196,68,26,0.08)", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12, fontWeight: 600, color: "#C4441A", cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}>
                              <IcTrash /> Supprimer
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* ══ RÉSERVATIONS ══ */}
          {onglet === "reservations" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>
                  {reservations.length} réservation{reservations.length !== 1 ? "s" : ""}
                  {resasAttente.length > 0 && <span style={{ color: "#C4841A", fontWeight: 700 }}> · {resasAttente.length} en attente</span>}
                </p>
              </div>

              <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                {["tous", "en_attente", "confirmee", "annulee"].map(s => (
                  <button key={s} onClick={() => setFiltreStatut(s)}
                    style={{ padding: "7px 16px", borderRadius: 20, border: `1.5px solid ${filtreStatut === s ? "#C4441A" : "#E8DCC8"}`, background: filtreStatut === s ? "#C4441A" : "white", color: filtreStatut === s ? "white" : "#7A5A3A", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    {s === "tous" ? "Toutes" : STATUT_RESA[s]?.label}
                  </button>
                ))}
              </div>

              {resasFiltrees.length === 0
                ? <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A", fontSize: 14 }}>Aucune réservation</div>
                : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {resasFiltrees.map(r => (
                      <div key={r.id} style={{ background: "white", borderRadius: 14, border: `1.5px solid ${r.statut === "en_attente" ? "rgba(196,132,26,0.35)" : "#E8DCC8"}`, padding: "20px 24px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                          <div style={{ flex: 1, minWidth: 200 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                              <span style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008" }}>
                                {r.nomClient} {r.prenomClient}
                              </span>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>
                                {STATUT_RESA[r.statut]?.label}
                              </span>
                            </div>
                            <div style={{ fontSize: 13, color: "#7A5A3A", marginBottom: 4 }}>
                              {formatDate(r.dateArrivee)} → {formatDate(r.dateDepart)} · {r.nbNuits} nuit{r.nbNuits > 1 ? "s" : ""} · {r.nbVoyageurs} pers.
                            </div>
                            <div style={{ display: "flex", gap: 16, fontSize: 12, color: "#7A5A3A", marginBottom: 4 }}>
                              <span style={{ display: "flex", alignItems: "center", gap: 4 }}><IcPhone /> {r.telephoneClient}</span>
                              <span style={{ display: "flex", alignItems: "center", gap: 4 }}><IcMail /> {r.emailClient}</span>
                            </div>
                            <div style={{ fontSize: 12, color: "#C4441A", fontWeight: 600 }}>Paiement : {r.modePaiement}</div>
                            {r.message && (
                              <div style={{ marginTop: 8, fontSize: 12, color: "#7A5A3A", background: "#FAF5EC", borderRadius: 8, padding: "8px 12px", lineHeight: 1.6 }}>
                                💬 {r.message}
                              </div>
                            )}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#C4441A" }}>{formatPrix(r.total)}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A", marginBottom: 14 }}>{r.nbNuits} nuit{r.nbNuits > 1 ? "s" : ""}</div>
                            {r.statut === "en_attente" && (
                              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button className="btn-success" onClick={() => confirmerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 16px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcCheck /> Confirmer
                                </button>
                                <button className="btn-primary" onClick={() => annulerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 16px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcX /> Refuser
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </>
          )}

          {/* ══ HISTORIQUE ══ */}
          {onglet === "historique" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Historique</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{resasConfirmees.length} séjour{resasConfirmees.length !== 1 ? "s" : ""} confirmé{resasConfirmees.length !== 1 ? "s" : ""}</p>
              </div>
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {reservations.length === 0
                  ? <div style={{ padding: 40, textAlign: "center", color: "#7A5A3A", fontSize: 14 }}>Aucune réservation pour le moment</div>
                  : (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ background: "#FAF5EC" }}>
                          {["Client", "Email", "Arrivée", "Départ", "Nuits", "Total", "Statut"].map(h => (
                            <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {reservations.map((r, i) => (
                          <tr key={r.id} style={{ borderBottom: i < reservations.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                            <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.emailClient}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{formatDate(r.dateArrivee)}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{formatDate(r.dateDepart)}</td>
                            <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{r.nbNuits}</td>
                            <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, color: "#3D6B2E" }}>{formatPrix(r.total)}</td>
                            <td style={{ padding: "14px 20px" }}>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>
                                {STATUT_RESA[r.statut]?.label}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                }
              </div>
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
}